import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable } from 'rxjs';
import { WINDOW } from '../tokens/window';

const USER_NAME_LOCAL_STORAGE_KEY = 'userName';

@Injectable({
  providedIn: 'root',
})
export class UserNameService {
  private userName: string | null;

  private userNameSubject: BehaviorSubject<string | null>;

  readonly userName$: Observable<string | null>;

  constructor(@Inject(WINDOW) private window: Window) {
    this.userName = this.window.localStorage.getItem(USER_NAME_LOCAL_STORAGE_KEY);
    this.userNameSubject = new BehaviorSubject<string | null>(this.userName);
    this.userName$ = this.userNameSubject.asObservable();

    // In case someone logged out (or logged in as a different user) in another tab
    fromEvent<StorageEvent>(this.window, 'storage').subscribe((event) => {
      if (event.key === USER_NAME_LOCAL_STORAGE_KEY && event.newValue !== this.userName) {
        this.userName = event.newValue;
        this.userNameSubject.next(this.userName);
      }
    });
  }

  setUserName(userName: string | null): void {
    if (this.userName !== userName) {
      this.userName = userName;
      if (userName != null) {
        this.window.localStorage.setItem(USER_NAME_LOCAL_STORAGE_KEY, userName);
      } else {
        this.window.localStorage.removeItem(USER_NAME_LOCAL_STORAGE_KEY);
      }
      this.userNameSubject.next(this.userName);
    }
  }

  getUserName() {
    return this.userName;
  }
}
